module.exports = __webpack_public_path__ + "media/images/app/visitors/how-it-works/hero-84f5c3afc24f469c633e9f74898d33ad.webp";